import { Handle, Node, NodeProps, Position, useReactFlow } from '@xyflow/react';
import { IODataType, NodeDataType } from './types';
import { Flex, Select } from 'antd';

export type IONodeType = Node<
  { isOutput: boolean; id: number; dataType: IODataType } & NodeDataType,
  'IO'
>;

export default function IONode({
  data: { isOutput, dataType, id },
  isConnectable,
  id: nodeId,
}: NodeProps<IONodeType>) {
  const { updateNodeData } = useReactFlow();

  const className = `io-node io-node-${dataType}`;
  if (isOutput) {
    return (
      <div className={className}>
        <Handle
          type="target"
          position={Position.Top}
          isConnectable={isConnectable}
          className={`data-type-${dataType}`}
        />
        Output {id}
      </div>
    );
  }
  return (
    <div className={className}>
      <Flex justify="center" align="center" vertical>
        <h4>Input {id}</h4>
        <Select
          className="nodrag"
          options={[
            { label: 'Text', value: 'text' },
            { label: 'Doc', value: 'file' },
            { label: 'Image', value: 'image' },
          ]}
          value={dataType}
          onChange={(val) => {
            updateNodeData(nodeId, { dataType: val });
          }}
        />
      </Flex>
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className={`data-type-${dataType}`}
      />
    </div>
  );
}
